module.exports = __webpack_public_path__ + "media/images/seats-c199864b4c71825c91d9a51afadc5174.svg";